export default function (_req, res, next) {
  res.setHeader('X-Frame-Options', 'SAMEORIGIN')
  next()
}
